"use client";

import { createContext } from "@pharaday/utils";
import { type ReactNode } from "react";

export const MOBILE_WIDTH = 480;

export interface BreadcrumbData {
  namespace?: string;
  appName?: string;
  appUrl?: string;
  breadcrumbs: { label: ReactNode; url?: string }[];
  trailingContent?: ReactNode;
}

export interface LayoutContext {
  openSidebar?: boolean;
  setOpenSidebar?: (value: boolean) => void;
  breadcrumbData?: BreadcrumbData;
  setBreadcrumbData?: (value?: BreadcrumbData) => void;
  contentBodyElement?: HTMLElement | null;
  setContentBodyElement?: (element: HTMLElement | null) => void;
  banner: boolean;
}

const [useLayoutContext, LayoutContextProvider] = createContext<LayoutContext>();

export { LayoutContextProvider, useLayoutContext };
